import { push } from 'connected-react-router';
import store from 'index';
import queryString from 'query-string';
import * as urlQueryFields from 'router/urlQueryFields';

let init = false;
let pendingUpdates = {}; // Track separate timeouts for each query key

export function pushURLQuery(queryKey, queryValue) {
  if (!init) {
    console.warn(`[pushURLQuery] Blocked! init is false. Cannot update URL for ${queryKey}`);
    return;
  }

  // Clear any pending update for this specific key
  if (pendingUpdates[queryKey]) {
    clearTimeout(pendingUpdates[queryKey]);
  }

  // Use setTimeout to avoid updating during render and debounce rapid updates
  pendingUpdates[queryKey] = setTimeout(() => {
    const urlQuery = queryString.parse(store.getState().router.location.search);
    const currentValue = urlQuery[queryKey];
    const newValue = queryValue;

    // Only update if the value has actually changed
    if (currentValue !== newValue) {
      urlQuery[queryKey] = newValue;
      const newUrl = `?${queryString.stringify(urlQuery)}`;
      store.dispatch(push(newUrl));
    }
    pendingUpdates[queryKey] = null;
  }, 100); // Debounce by 100ms
}

export function getURLQueries(queryField) {
  // Try to get from router state first
  let search = store.getState().router?.location?.search;

  // Fallback to window.location.search if router state is empty
  if (!search || search === '') {
    search = window.location.search;
  }

  const queries = queryString.parse(search);

  try {
    // Enable URL updates when getURLQueries is called
    if (queryField === urlQueryFields.layers) init = true;
    if (!queries[queryField]) init = true;
    if (!queryField) {
      // When requesting all queries, enable URL updates
      init = true;
      return queries;
    }
    if (queries[queryField]) return JSON.parse(queries[queryField]);
  } catch (error) {
    console.error('[getURLQueries] Parse error for', queryField, ':', error);
  }
  return null;
}

export { urlQueryFields };

export default { pushURLQuery, getURLQueries, urlQueryFields };
